import ctl from '@netlify/classnames-template-literals';

export const inputStyle = ctl(`
  w-full
  h-full
  text-center
  border-r
  border-chisese-silver
  outline-none
  rounded-tr-none
  rounded-br-none
  text-sm
`);

export const inputContainerStyle = ctl(`
  min-w-[32px]
  max-w-[60px]
  flex-center
`);

export const containerStyle = ctl(`
  flex
  items-center
  relative
  p-2
  gap-4
  border-[1px] 
  border-white
  rounded-md
  border-chinese-silver
  focus:border-chinese-silver 
  active:border-chinese-silver
  outline-none
`);

export const previewTextStyle = ctl(`
  text-sm
  cursor-default
`);

export const iconStyle = ctl(`
  text-md
  cursor-pointer
`);

export const iconsContainerStyle = ctl(`
  flex
  items-center
  gap-4
`);

export const messageStyle = ctl(`
  w-full
  absolute
  top-full
  left-0
  error-message
  font-[600]
`);
